import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Callout from "./callout";
import iconSalesTeam from "../images/icons/reputable-clients.svg";
var Contact = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(Contact, _React$Component);
    function Contact() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Contact.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ React.createElement("section", {
            className: "contact"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "grid"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Contact Our Sales Team",
            titlePosition: "center",
            message: "Get in touch with our sales team and see why American Softgels is the right fit for your business.",
            icon: iconSalesTeam
        })), /*#__PURE__*/ React.createElement("div", {
            className: "grid grid--half mb-4 mmb-2"
        }, /*#__PURE__*/ React.createElement(Callout, {
            title: "Brad McCurley",
            message: "",
            titlePosition: "center"
        }, /*#__PURE__*/ React.createElement("a", {
            href: "mailto:brad@americansoftgelsinc.com"
        }, "brad@americansoftgelsinc.com")), /*#__PURE__*/ React.createElement(Callout, {
            title: "Mike Fox",
            message: "",
            titlePosition: "center"
        }, /*#__PURE__*/ React.createElement("a", {
            href: "mailto:brad@americansoftgelsinc.com"
        }, "mike@americansoftgelsinc.com"))));
    };
    return Contact;
}(React.Component);
export { Contact as default };
